import React from 'react';

import { useSetDefaultMenu } from 'src/modules/designStudio/components/DesignMenu/Menu/useSetDefaultMenu';
import { LandscapeUI } from 'src/modules/designStudio/components/DesignStudio/UILayer/LandscapeUI';
import { MobileUI } from 'src/modules/designStudio/components/DesignStudio/UILayer/MobileUI';
import type { UILayerProps } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import { Mode } from 'src/modules/designStudio/providers';
import { useIsLandscape } from 'src/shared/hooks';

import { DesignMenu } from '../../DesignMenu';
import { NavBar } from '../../NavBar';

// Intention of moving this to its own component, will hopefully give us a place
// to encapsulate the logic in determinging which UI to render as experience
// diverge between mobile and tablet/desktop
const UILayer = (props: UILayerProps) => {
  const {
    setMenu,
    mode,
    showDesignChanges,
    menu,
    jobId,
    loading,
    setCardHeight,
    userId,
    viewer,
  } = props;

  const [isLandscape] = useIsLandscape();
  /**
   * This hook handles setting the default menu that opens when design studio loads.
   */
  useSetDefaultMenu({ setMenu, mode });

  if (mode === Mode.PRO_VIEW || mode === Mode.SHARE) {
    return (
      <>
        <NavBar isOnline menu={null} setMenu={setMenu} showUndoRedo={false} />
        {showDesignChanges && (
          <DesignMenu
            jobId={jobId}
            menu={loading ? null : menu}
            setCardHeight={setCardHeight}
            toolbarRef={null}
            userId={userId}
            viewer={viewer}
          />
        )}
      </>
    );
  }

  return isLandscape ? <LandscapeUI {...props} /> : <MobileUI {...props} />;
};

export { UILayer };
